import { LocalDate } from "@js-joda/core";
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { SalaryNotice } from "model/Salary";
import { Api } from "services/api/api.service";

type UseMonthlySalaryReturn = {
  currentDate: LocalDate;
  getSalaries: () => void;
  page: number;
  salaryNotices: SalaryNotice[];
  setCurrentDate: (date: LocalDate) => void;
  setPage: Dispatch<SetStateAction<number>>;
  totalPages: number;
};

const FETCH_AMOUNT = 25;

export const useMonthlySalary = (
  companyId: number | undefined,
): UseMonthlySalaryReturn => {
  const [currentDate, setCurrentDate] = useState(LocalDate.now());
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [salaryNotices, setSalaryNotices] = useState<SalaryNotice[]>([]);
  const latestRequestIdRef = useRef(0);

  const getSalaries = useCallback((): void => {
    if (!companyId) return;
    const requestId = ++latestRequestIdRef.current;
    Api()
      .company.salary.getSalaries(
        companyId,
        page,
        FETCH_AMOUNT,
        currentDate.year(),
        currentDate.monthValue(),
      )
      .then((res) => {
        if (requestId !== latestRequestIdRef.current) return;
        setSalaryNotices(res.data.salaryNotices);
        setTotalPages(Math.ceil(res.data.total / FETCH_AMOUNT));
      })
      .catch(() => {});
  }, [companyId, page, currentDate]);

  useEffect(() => {
    getSalaries();
  }, [getSalaries]);

  return {
    currentDate,
    getSalaries,
    page,
    salaryNotices,
    setCurrentDate,
    setPage,
    totalPages,
  };
};
